angular.module('unica_report.report_controllers')

.controller('ReportListController', function(
	$rootScope, $scope, $state, $stateParams,
	$injector, $ocLazyLoad,
	CONFIG,
	ReportListService, EventListService
) {

	$scope.event_id = $stateParams.event_id;
	$scope.other_events = '';

	$rootScope.getEvent( $stateParams.event_id );

	$scope.chartOptions = {
		legend: {
			display: true,
			position: 'top',
		}

	};

	$scope.chartColors = [ '#C21B17', '#AA1B17', '#EDEDED', '#979797', '#A0A0A0', '#7C7C7C', '#4D5360'];
	$scope.chartCheckedColors = [ '#C21B17', '#EDEDED', '#AA1B17', '#979797', '#434343', '#7C7C7C', '#4D5360'];

	setupReports();

	function setupReports()
	{
		loadInvitationListsReport();
		loadInvitationsByTypeReport();
		loadInvitationsByStatusReport();
		loadCheckinReport();
		loadCheckinByStageReport();
		loadCheckinByTimeReport();
	}

	function loadInvitationListsReport()
	{
		$scope.showLoader();
		ReportListService
			.invitationList( $stateParams.event_id )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					$scope.invitationListsReport = data;
				}
			});
	}

	function loadInvitationsByTypeReport()
	{
		$scope.showLoader();
		ReportListService
			.invitationsByType( $stateParams.event_id )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					$scope.invitationsTypeReport = data;
				}
			});
	}

	function loadInvitationsByStatusReport()
	{
		$scope.showLoader();
		ReportListService
			.invitationsByStatus( $stateParams.event_id )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					$scope.invitationsStatusReport = data;
				}
			});
	}

	function loadCheckinReport()
	{
		$scope.showLoader();
		ReportListService
			.checkin( $stateParams.event_id )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					$scope.checkinReport = data;
				}
			});
	}

	function loadCheckinByStageReport()
	{
		$scope.showLoader();
		ReportListService
			.checkinByStage( $stateParams.event_id )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					$scope.checkinByStageReport = data;
				}
			});
	}

	function loadCheckinByTimeReport()
	{
		$scope.showLoader();
		ReportListService
			.checkinByTime( $stateParams.event_id )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					$scope.checkinByTimeReport = data;
				}
			});
	}


	$scope.downloadReportInvitationsByListAndCategory = false;
	$scope.reportInvitationsByListAndCategoryUrl      = '';

	$scope.prepareReportInvitationsByListAndCategory = function() {
		$scope.showLoader();

		ReportListService
			.invitationsByListAndCategory( $stateParams.event_id )
			.then(function(url) {
				$scope.hideLoader();

				if ( url ) {
					$scope.downloadReportInvitationsByListAndCategory = true;
					$scope.reportInvitationsByListAndCategoryUrl = url;
				}
			});
	};


	$scope.downloadReportInvitationsByZoneManagerAndArea = false;
	$scope.reportInvitationsByZoneManagerAndAreaUrl      = '';

	$scope.prepareReportInvitationsByZoneManagerAndArea = function() {
		$scope.showLoader();

		ReportListService
			.invitationsByZoneManagerAndArea( $stateParams.event_id )
			.then(function(url) {
				$scope.hideLoader();

				if ( url ) {
					$scope.downloadReportInvitationsByZoneManagerAndArea = true;
					$scope.reportInvitationsByZoneManagerAndAreaUrl = url;
				}
			});
	};


	$scope.downloadReportCampaignsStatus = false;
	$scope.reportCampaignsStatusUrl      = '';

	$scope.prepareReportCampaignsStatus = function() {
		$scope.showLoader();

		ReportListService
			.campaignsStatus( $stateParams.event_id )
			.then(function(url) {
				$scope.hideLoader();

				if ( url ) {
					$scope.downloadReportCampaignsStatus = true;
					$scope.reportCampaignsStatusUrl = url;
				}
			});
	};


	$scope.downloadReportDeclinedInvitations = false;
	$scope.reportDeclinedInvitationsUrl      = '';

	$scope.prepareReportDeclinedInvitations = function() {
		$scope.showLoader();

		ReportListService
			.declinedInvitations( $stateParams.event_id )
			.then(function(url) {
				$scope.hideLoader();

				if ( url ) {
					$scope.downloadReportDeclinedInvitations = true;
					$scope.reportDeclinedInvitationsUrl = url;
				}
			});
	};


	$scope.downloadExportEvent = false;
	$scope.downloadExportEventSmart = false;
	$scope.downloadExportStage = [];
	$scope.downloadExportVideoRanking = false;
	$scope.exportEventUrl      = '';
	$scope.exportEventSmartUrl      = '';
	$scope.exportStageUrl      = [];
	$scope.exportVideoRankingUrl      = '';

	$scope.prepareExportEventUrl = function() {
		$scope.showLoader();
		EventListService
			.exportEvent( $stateParams.event_id, {
				other_events: $scope.other_events
			} )
			.then(function(url) {
				$scope.hideLoader();

				if ( url ) {
					$scope.downloadExportEvent = true;
					$scope.exportEventUrl      = url;
				}
			});
	};

	$scope.prepareExportEventSmartUrl = function() {
		$scope.showLoader();
		EventListService
			.exportEventSmart( $stateParams.event_id )
			.then(function(url) {
				$scope.hideLoader();

				if ( url ) {
					$scope.downloadExportEventSmart = true;
					$scope.exportEventSmartUrl      = url;
				}
			});
	};

	$scope.prepareExportStageUrl = function( stageId ) {
		$scope.showLoader();
		EventListService
			.exportStage( stageId )
			.then(function(url) {
				$scope.hideLoader();

				if ( url ) {
					$scope.downloadExportStage.push(stageId);
					$scope.exportStageUrl['stage'+stageId]     = url;
				}
			});
	};


	$scope.prepareExportVideoRankingUrl = function() {
		$scope.showLoader();
		EventListService
			.exportEventVideoRanking( $stateParams.event_id )
			.then(function(url) {
				$scope.hideLoader();

				if ( url ) {
					$scope.downloadExportVideoRanking = true;
					$scope.exportVideoRankingUrl      = url;
				}
			});
	};

});